export const LICENSES_ENDPOINTS = {
  REASSIGN_RESELLER: 'Licenses/reassign-reseller',
  TRANSACTIONS_EXPORT: '/insights/transactions/export',
  LICENSES_VERSIONS: 'LicenseVersions',
}
